import { ServicePage } from '../ServicePage';

export default function Corporate() {
  return (
    <ServicePage
      categoryKey="corporate"
      heroImage="https://images.unsplash.com/photo-1753030768124-dba306907bba?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1800"
      overline="Hizmetlerimiz"
      headline="Kurumsal Etkinlikler"
      headlineAccent="Prestij. Prodüksiyon. Etki."
      intro="Gala gecelerinden marka lansmanlarına, liderlik zirvelerinden VIP kutlamalara; her kurumsal anı stratejik tasarım ve kusursuz prodüksiyon disipliniyle taçlandırıyoruz. Markanızı doğru sahnede sunuyoruz."
      inclusions={[
        { title: 'Sahne & Süsleme Tasarımı', desc: 'Markanızın kimliğini yansıtan özel sahne tasarımları' },
        { title: 'Ses & Teknik Prodüksiyon', desc: 'Profesyonel ses, ışık ve teknik ekipman kurulumu' },
        { title: 'VIP Misafir Yönetimi', desc: 'Protokol koordinasyonu ve VIP karşılama hizmetleri' },
        { title: 'Catering Koordinasyonu', desc: 'Premium yemek ve ikram organizasyonu' },
        { title: 'Medya & Basın İlişkileri', desc: 'Basın davetiyesi ve medya koordinasyonu' },
        { title: 'Etkinlik Günü Koordinasyon', desc: 'Baştan sona sahada deneyimli ekip' },
        { title: 'A/V Ekipman Yönetimi', desc: 'LED ekran, projeksiyon ve ses sistemleri' },
        { title: 'Post-Etkinlik Raporu', desc: 'Etkinlik analizi ve performans raporu' },
      ]}
      processSteps={[
        { num: '01', title: 'Stratejik Brifing', desc: 'Kurumsal hedeflerinizi, marka kimliğinizi ve etkinlik beklentilerinizi detaylıca analiz ediyoruz.' },
        { num: '02', title: 'Konsept & Tasarım', desc: 'Markanıza özel etkinlik konseptini, sahne tasarımını ve tüm estetik detayları belirliyoruz.' },
        { num: '03', title: 'Lojistik Planlama', desc: 'Mekân seçimi, tedarikçi koordinasyonu, zaman çizelgesi ve bütçe yönetimini üsleniyoruz.' },
        { num: '04', title: 'Prodüksiyon & Kurulum', desc: 'Tüm teknik ekipman, dekor ve sahne unsurlarını ekibimiz tarafından kuruyoruz.' },
        { num: '05', title: 'Etkinlik & Teslimat', desc: 'Etkinlik günü tam koordinasyonla saha yönetimini üsleniyoruz. Her detayın kusursuz işlediğini garanti ediyoruz.' },
      ]}
      signatureDetails={{
        title: 'Kurumsal Kimliğinizi Sahnede Yaşatıyoruz',
        body: 'Her kurumsal etkinlik, markanızın değerlerini, vizyonunu ve üslubunu yansıtması gereken stratejik bir fırsattır. İMER, bu fırsatı en yüksek etkiyle değerlendirmenizi sağlar.',
        list: [
          'C-suite ve üst düzey yönetici etkinlikleri',
          'Yıllık kurumsal konferans ve zirveler',
          'Marka lansmanı ve ürün tanıtım etkinlikleri',
          '500+ kişilik gala geceleri',
          'Kurumsal ödül törenleri',
        ],
        image: 'https://images.unsplash.com/photo-1651975414388-f33abc8f82a8?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=900',
      }}
      faqItems={[
        { q: 'Kaç kişilik etkinlikler düzenliyorsunuz?', a: '50 kişiden 2000+ kişiye kadar her ölçekte kurumsal etkinlik planlama kapasitemiz mevcuttur.' },
        { q: 'Uluslararası konuklar için protokol yönetimi sağlıyor musunuz?', a: 'Evet, uluslararası misafirler ve diplomatik protokol için özel koordinasyon hizmeti sunuyoruz.' },
        { q: 'Etkinlik günü ekibiniz sahadaki mı?', a: 'Evet, deneyimli proje ekibimiz etkinlik başlangıcından bitimişine kadar sahadadır.' },
      ]}
    />
  );
}
